<ng-template #projectedContent>
  <!-- Any custom template goes here -->
  <ng-content></ng-content>

  <!-- For nested components pass as template -->
  <ng-container *ngIf="customTemplate">
    <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
  </ng-container>

  <!-- Button Label comes from here -->
  <ng-container *ngIf="buttonConfig.label && !hasProjectedContent">
    {{ buttonConfig.label | transloco }}
  </ng-container>

  <!-- Arrow (Black | White) -->
  <ng-container *ngIf="buttonConfig.arrow">
    <div class="w-6 h-6 px-1 py-2 flex justify-center items-center">
      <div class="origin-top-left relative">
        <img 
          alt="Arrow" 
          [src]="arrowIconUrl | cdnUrl:'icons'" 
          [class.rotate-180]="websiteService.language === 'ar'" 
        />
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-container [ngSwitch]="buttonTag">
  <!-- Button w/ Click Event -->
  <button
    *ngSwitchCase="'button'"
    [class]="getButtonClasses()"
    [disabled]="buttonConfig.disabled"
    (click)="handleClick($event)"
    type="button"
  >
    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
  </button>

  <!-- Internal Routes -->
  <a
    *ngSwitchCase="'routerLink'"
    [routerLink]="route?.link"
    [queryParams]="route?.queryParams"
    [class]="getButtonClasses()"
    [class.cursor-not-allowed]="buttonConfig.disabled"
    [class.pointer-events-none]="buttonConfig.disabled"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
  </a>

  <!-- External Routes -->
  <a
    *ngSwitchCase="'externalLink'"
    [href]="route?.link"
    [target]="route?.target || '_blank'"
    rel="noopener noreferrer"
    [class]="getButtonClasses()"
    [class.cursor-not-allowed]="buttonConfig.disabled"
    [class.pointer-events-none]="buttonConfig.disabled"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
  </a>
</ng-container>